<template>
  <div data-v-1ee23c10="" class="news-list-container" style="top: 0">
    <ul data-v-1ee23c10="" class="news-list">
      <van-tabs v-model="active" color="#cca352" title-active-color="#cca352" title-inactive-color="#6a6a73" background="#282828" style="margin-bottom: 10px">
       
          <van-tab v-for="(item, index) in activitytypelist" :key="index" :title="item.name" :name="item.key">
            <template #title>
               <div v-if="item.key != -1 && noticeList.filter(e => e.type == item.key && e.is_read != 1) && noticeList.filter(e => e.type == item.key && e.is_read != 1).length > 0 " style="position: relative;width: 100%;height: 22px;">
                <div style="position: absolute;width: 6px;height: 6px;background-color: red;color:#fff;border-radius: 50%;font-size: 10px;text-align: center;
                line-height: 14px;text-align: center;top: 0px;right: 0px;"></div>
                {{ item.name }}</div>
               <span v-else>{{ item.name }}</span>
            </template>
          </van-tab>
      </van-tabs>
      <div v-if="active == -1">
        <div v-if="usrserve && usrserve.length > 0">
          <div style="margin: 10px 0; padding: 10px" v-if="usrserve.filter(e => e.is_top == 1) && usrserve.filter(e => e.is_top == 1).length > 0">
            <div style="float: left; width: 50px; height: 50px; margin-right: 10px">
              <img :src="usrserve.filter(e => e.is_top == 1)[0].img" style="width: 100%; height: 100%; object-fit: cover; border-radius: 50%" />
            </div>
            <div style="height: 50px">
              <p style="font-size: 18px; color: #fff; margin-top: 5px">{{ usrserve.filter(e => e.is_top == 1)[0].title }}</p>
              <span>{{ usrserve.filter(e => e.is_top == 1)[0].content }}</span>
            </div>
            <div style="border-top: 1px solid #666; padding: 10px 0">
              <div style="color: #cca352; border: 1px solid #cca352; padding: 8px 14px; text-align: center">
                <a :href="url" target="_bank" style="color: #cca352"> 点击咨询专属客服</a>
              </div>
            </div>
          </div>
          <div style="background-color: #000; height: 10px; margin-left: -20px; width: calc(100% + 40px)"></div>
          <li v-for="(item, index) in usrserve.filter(e => e.is_top != 1)" :key="index" class="news-item">
            <div style="padding: 10px 0">
              <div style="float: left; width: 50px; height: 50px; margin-right: 10px">
                <img :src="item.img" style="width: 100%; height: 100%; object-fit: cover; border-radius: 50%" />
              </div>
              <div style="height: 50px">
                <p style="font-size: 18px; color: #fff; margin-top: 5px">{{ item.title }}</p>
                <span>{{ item.content }}</span>
              </div>
              <div style="border-top: 1px solid #666; padding: 10px 0">
                <div style="background-color: #cca352; color: #fff; float: left; padding: 3px 8px; border-radius: 5px; margin-top: 6px">助理推荐</div>
                <div style="float: left; color: #fff; margin-left: 5px; height: 37px; line-height: 37px">{{ item.account }}<span @click="copy(item.account)" style="font-size: 12px; margin-left: 4px; color: #cca352">复制账号</span></div>
                <div style="color: #cca352; border: 1px solid #cca352; padding: 8px 14px; text-align: center; float: right">
                  <a :href="item.download_url" target="_bank" style="color: #cca352">{{ item.download_describe }}</a>
                </div>
                <div style="clear: both" />
              </div>
            </div>
          </li>
        </div>
      </div>
      <div v-else>
        <li data-v-1ee23c10="" id="31234019" v-for="(item, index) in noticeList.filter(e => e.type == active)" :key="index" class="news-item">
          <div style="float: left;"><van-badge dot v-if="item.is_read != 1"><van-icon name="volume-o" size="32" /></van-badge>
            <van-icon v-else name="volume-o" size="32" />
          </div>
          <a @click="$parent.goNav(`/myNewsInfo?id=${item.id}`)" style="flex: 1">
            <div data-v-1ee23c10="" class="news-item-checkbox news-item-left" style="display: none">
              <label data-v-1ee23c10="" class="checkbox"
                ><img
                  data-v-1ee23c10=""
                  src="data:image/png;base64,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"
                  alt=""
                  class="checkbox-icon"
                  style="display: none"
                /><img
                  data-v-1ee23c10=""
                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA4hpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDowZTUyOGI2Yy02YTYzLTRkZmMtYTJkOC1hY2UwM2VjYWZmYzgiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6N0FFMjFDNTcxMUY5MTFFOEJENjJCMTY5RjVERTQzQ0QiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6N0FFMjFDNTYxMUY5MTFFOEJENjJCMTY5RjVERTQzQ0QiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUuNSAoTWFjaW50b3NoKSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjA4NjhkNDJiLTExNTEtNGVkNC04MGMyLTY4YzYzZjEwYTU4OSIgc3RSZWY6ZG9jdW1lbnRJRD0iYWRvYmU6ZG9jaWQ6cGhvdG9zaG9wOjc2ZWNlODRhLWNkZjYtMTE3YS04Y2RhLThlNmZlODk1OGRiOSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PkPISZkAAAGiSURBVHja7Jq7SgNBGEYnq0Qk5gmsTOUNFRu1FYuob6Bt3CjeyIsoakCF+AD2KimCtTZqSBRsAjZ5ghWJN/x+8o0seYGdgX/gsNnsFudkdyfFbCoMQ9MzxkEBLIMRMGCSHR3QAlVQAS/xg0HscxqUQQOUwKgD8oYOY3QStzMw2Bsg8tdgG3yDY7AAsiCVMFm6lOlWBFd0/g84BEugDebBPrgDkQNXIKLLLpij4yI4sAETrJJ7bRU8GnfHE1ih66a4B3xg+8ApT3B91OkqzgUJyPPApfFnWNe8BOS48+BRgL3Nc4F9mjE+PQro2NkzMJ4PDdAADdAADdAADdAADdAADdAADdAADdAADdAADdAADdCAZALsukDaI+8hbiMJaHFn1qOASW7fJKDKnTWPAta5rUnABfgB8s7BtAfyU2CDzhUJaIJz013Sl9X6GYflxe2GruLctLOQvIdQA8PgHhyZ7op9xgHpDF1O6CaOt3Q2/TxJZiJZpZfl+y2wR1wbv/zlS3b2jP8PyBc7vMfkCryCLwek38EzneQZlVcMPuzBPwEGAOCPSsEYWgQCAAAAAElFTkSuQmCC"
                  alt=""
                  class="checkbox-icon"
                />
                <input data-v-1ee23c10="" type="checkbox" class="checkbox-input" />
              </label>
            </div>
            <div data-v-1ee23c10="" class="news-item-right">
              <div data-v-1ee23c10="" class="news-content-container">
                <h4 data-v-1ee23c10="" class="new-title-wrapper">
                  <span data-v-1ee23c10="" class="title">{{ item.title }}</span>
                  <span data-v-1ee23c10="" class="time">{{ item.created_at }}</span>
                </h4>
                <p data-v-1ee23c10="" class="news-content" v-html="item.content"></p>
              </div>
              <div data-v-1ee23c10="" class="icon-arrow"></div>
            </div>
          </a>
        </li>
      </div>
    </ul>
  </div>
</template>
<script>
import { Toast } from 'vant';
export default {
  name: 'myNews',
  data () {
    return {
      noticeList: [],
      page: 1,
      activitytypelist: [
        { key: -1, name: '客服' },
        { key: 1, name: '通知' },
        { key: 2, name: '活动' },
        { key: 3, name: '公告' },
        { key: 4, name: '推荐' },
      ],
      active: -1,
      usrserve: null,
      url: null,
    };
  },
  created () {
    let that = this;
    
    
    // that.getsysserver()
    that.usrgetserve();
    if(that.$store.state.token){
      that.getnoticeList();
      
    }
  },
  methods: {
    copy (val) {
      // 创建input标签
      var input = document.createElement('input');
      // 将input的值设置为需要复制的内容
      input.value = val;
      // 添加input标签
      document.body.appendChild(input);
      // 选中input标签
      input.select();
      // 执行复制
      document.execCommand('copy');
      // 成功提示信息
      Toast('复制成功');
      // 移除input标签
      document.body.removeChild(input);
    },
    getsysserver () {
      let that = this;
      that.$apiFun.post('/api/getservicerurl', {}).then(res => {
        if (res.code != 200) {
          that.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.url = res.data.url;
        }
      });
    },
    usrgetserve () {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun
        .get('/api/getKefu')
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.usrserve = res.data;
            if(this.usrserve.filter(e => e.is_top == 1) && this.usrserve.filter(e => e.is_top == 1).length > 0){
              that.url = this.usrserve.filter(e => e.is_top == 1)[0].url;
            }
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    getnoticeList () {
      let that = this;
      let page = that.page;
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/noticeList', { page, limit: 999 })
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.noticeList = res.data.data;
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
  },
  mounted () {
    let that = this;
  },
  updated () {
    let that = this;
  },
};
</script>

<style lang="scss" scoped>
@import '../../../static/css/chunk-099d4415.690b75b1.css';
</style>



// WEBPACK FOOTER //
// src/components/main/myNews.vue